import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext({ settings: {}, loading: true });

const FALLBACK = {
  company_name: "Aimway Technology Solutions",
  tagline: "India's first AI + RTM helmet sanitization machine",
  phone: "+91 00000 00000",
  email: "hello@aimway.in",
  whatsapp: "910000000000",
  address: "India",
  map_embed: "https://www.google.com/maps?q=India&output=embed",
  facebook: "#",
  instagram: "#",
  linkedin: "#",
};

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/settings")
      .then(({ data }) => setSettings({ ...FALLBACK, ...(data || {}) }))
      .catch(() => setSettings(FALLBACK))
      .finally(() => setLoading(false));
  }, []);

  return <SiteContext.Provider value={{ settings, loading }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
